import Overlay from './components/Overlay.vue'

const Modal = {
  install (Vue, options) {
    this.EventBus = new Vue()

    // This is, how the plugin is used in the template section
    // <global-modal />
    Vue.component('global-modal', Overlay)

    // exposing global $modal object with method show()
    // method show() takes object params as argument
    // inside this object we can have modal title, text, styles... and also our callback confirm function
    Vue.prototype.$modal = {
      show (params) {
        // if we use this.$modal.show(params) inside our original Vue instance
        // we will emit 'show' event with parameters 'params'
        Modal.EventBus.$emit('show', params)
      }
    }
  }
}

export default Modal
